<app-login-stepper [isCalledFromDialog]="true" [startStep]="LoginStep.twoFactorAuthentication"
                   (complete)="closeDialog()"></app-login-stepper>
